import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import animationData from "../assets/payment-success.lottie";
import "./PaymentSuccessPage.css";
import Header from "../component/Header/Header";
import { Box, Container, Grid, Typography, Paper, Button } from "@mui/material";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import { QRCodeCanvas } from "qrcode.react";
import { toJpeg } from "html-to-image";
import Pspo from "../assets/pspo.webp";

function PaymentSuccessPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const uniqueKey = location.state?.uniqueKey;
    const qrRef = useRef(null);
    const imageRef = useRef(null);
    const qrString = uniqueKey?.toString();
    
    const offerData = {
        offername: "",
        offerdescription: "",
        isofferapplied: false
    }

    localStorage.setItem('offerData', JSON.stringify(offerData));

    const handleMenuClick = () => {
        navigate("/catalogue");
    };

    const handleTrackOrder = (uniqueKey) => {
        navigate(`/order-history/${uniqueKey}`);
    }

    const handleDownload = () => {
        const infoDiv = document.createElement("div");
        infoDiv.style.textAlign = "center";
        infoDiv.style.marginBottom = "20px";
        infoDiv.innerHTML = `
            <p style="margin: 0; font-size: 14px; font-weight: bold;">Order ID: ${uniqueKey}</p>
        `;
        
        // Append the details above the QR code
        qrRef.current.prepend(infoDiv);

        if (qrRef.current) {
            toJpeg(qrRef.current, { quality: 1.0, backgroundColor: "#ffffff" })
                .then((dataUrl) => {
                    qrRef.current.removeChild(infoDiv);

                    const link = document.createElement("a");
                    link.href = dataUrl;
                    link.download = `QR_Code_${uniqueKey}.jpeg`;
                    link.click();
                })
                .catch((error) => {
                    qrRef.current.removeChild(infoDiv);
                    console.error("Error generating QR code image", error);
                });
        }
    };

    useEffect(() => {
        if (!uniqueKey) {
            navigate("/catalogue");
        }
    }, [uniqueKey]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    if (!uniqueKey) {
        return null; // Prevent rendering if uniqueKey is invalid (redirect happens)
    }

    return (
        <div>
            <Header />
            <Container className="payment-success-root">
                <Paper elevation={3} className="ps-order-success-container">
                    <Box className="ps-icon-container">
                        {/* <CheckCircleIcon className="ps-success-icon"/> */}
                        {/* <img src={Pspo} alt="Logo" className="set-snr-img" /> */}
                        <DotLottieReact src={animationData} loop autoplay />
                        {/* <CheckCircleIcon className="ps-success-icon"/> */}
                        {/* <img src={Pspo} alt="Logo" className="set-snr-img" /> */}
                    </Box>
                    <Typography variant="h5" className="ps-title">
                        Your Order has been Placed!
                    </Typography>
                    <Typography variant="body1" className="ps-message">
                        Thank you for your order. Your order number is
                    </Typography>
                    <Typography variant="body1" className="payment-success-od">
                        <span>{uniqueKey}</span>
                    </Typography>
                    <Typography variant="body1" className="ps-next-steps">
                        Your food will be with you shortly. We hope you enjoy your meal!
                    </Typography>
                    <Typography variant="body1" className="ps-next-steps">
                        You can now track your order or return to the menu.
                    </Typography>
                    <div
                        ref={qrRef}
                        style={{
                            padding: "20px",
                        }}
                    >
                        <QRCodeCanvas value={qrString} size={150} />
                    </div>
                    <Button
                        variant="contained"
                        className="download-qr-btn"
                        onClick={handleDownload}
                        startIcon={<DownloadRoundedIcon />}
                    >
                        Download QR
                    </Button>
                    <div className="button-block">
                        <Button
                            variant="contained"
                            color="success"
                            className="ps-go-to-menu-button"
                            onClick={handleMenuClick}
                            startIcon={<MenuBookIcon />}
                        >
                            Menu Page
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            className="ps-go-to-menu-button"
                            onClick={() => handleTrackOrder(uniqueKey)}
                            startIcon={<GpsFixedIcon />}
                        >
                            Track Order
                        </Button>
                    </div>
                </Paper>
            </Container>
        </div>
    );
}

export default PaymentSuccessPage;
